/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, Tc, debug, SCS) {
	'use strict';

	/**
	 *
	 * Subscribes to channels: [EcommerceProductDataHub]
	 * Listens to channel events: [startProductDataSubscription, invalidateProductData]
	 * Triggers channel events: [subscribeForProductData]
	 *
	 * @namespace Tc.Module
	 * @class ProductImage
	 * @extends Tc.Module
	 */
	Tc.Module.ProductImage = Tc.Module.extend({

		on: function (callback) {
			var mod = this;
			mod.image = $('img', mod.$ctx);
			mod.image.data('default-src', mod.image.attr('src'));
			mod.image.data('default-alt', mod.image.attr('alt'));
			mod.size = mod.$ctx.data('size');
			mod.onStartProductDataSubscription();
			callback();
		},

		/**
		 * Channel listener to register for EcommerceProductDataHub events.
		 *
		 * @method onStartProductDataSubscription
		 * @return void
		 */
		onStartProductDataSubscription: function () {
			var mod = this,
				initialChannel = 'EcommerceProductDataHub';
			mod.sandbox.subscribe(initialChannel, mod);
			mod.fire('subscribeForProductData', {
				element: mod.$ctx,
				subscribe: function (channel, fetchDataOnSubscribe) {
					mod.productDataChannel = channel;
					mod.sandbox.unsubscribe(initialChannel, mod);
					mod.sandbox.subscribe(channel, mod);

					if (fetchDataOnSubscribe) {
						mod.fire('getInfo', {
							callback: function (data) {
								mod.onInvalidateProductData({info: data});
							}
						}, [mod.productDataChannel]);
					}
				}
			}, [initialChannel]);
		},

		/**
		 * Channel listener which gets called by EcommerceProductDataHub to notify about data changes.
		 *
		 * @method onInvalidateProductData
		 * @param {Object} data See EcommerceProductDataHub for details about the structure
		 * @return void
		 */
		onInvalidateProductData: function (data) {
			var mod = this, alt, src;
			if (mod.productDataChannel && data.info && data.info.product) {
				alt = data.info.family.getSeoName();
				if (mod.size === 'small') {
					src = data.info.product.getImageSmall();
				} else if (mod.size === 'mini') {
					src = data.info.product.getImageMini();
				} else {
					src = data.info.product.getImageBig();
				}
			}
			src = src || mod.image.data('default-src');
			alt = alt || mod.image.data('default-alt');
			mod.image.attr('src', src);
			mod.image.attr('alt', alt);
		}
	});

}(window.Tc.$, window.Tc, window.debug, window.SCS));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/ecommerce/clientlibs/shared/js/modules/Tc.Module.ProductImage.js
// module id = 252
// module chunks = 0